import { render, staticRenderFns } from "./EditMultiPartModal.vue?vue&type=template&id=229c1365&"
import script from "./EditMultiPartModal.vue?vue&type=script&lang=js&"
export * from "./EditMultiPartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports